<template>
    <div>
        <div class="container py-4 py-md-5 my-lg-5" v-if="isContentLoaded">
            <div class="page-content">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6" v-if="contact.acf.map_image">
                        <div class="" v-lazy-container="{ selector: 'img' }">
                            <img :data-src="`${contact.acf.map_image.url}`"  class="w-100 d-block m-auto img-fluid" />
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="pl-lg-5">
                          <div class="row">
                            <div class="col-12 col-md-5 col-lg-12">
                              <h1 class="page-title" v-html="contact.title.rendered"></h1>
                              <div v-html="contact.content.rendered"></div>
                            </div>
                            <div class="col-12 col-md-7 col-lg-12">
                              <div class="d-flex align-items-center" v-if="contact.acf.address">
                                <div class="icon map-marker mb-3"></div>
                                <div class="col" v-html="contact.acf.address"></div>
                              </div>

                              <div class="d-flex align-items-center" v-if="contact.acf.telephone">
                                <div class="icon telephone"></div>
                                <div class="col">
                                  <p class="m-0" v-for="(phone, key) in contact.acf.telephone" :key="key">
                                      <a :href="`tel:${phone.phone_number}`">{{ phone.phone_number }}</a>
                                  </p>
                                </div>
                              </div>

                              <a :href="contact.acf.google_map" class="btn light mt-5" target="_blank" v-if="contact.acf.google_map">{{ $t('message.viewmap') }}</a>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.page-content -->
        </div>
        <!-- /.container -->
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Contact',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      contact: [],
      isContentLoaded: false
    }
  },
  mounted () {
    this.getContact()
  },
  methods: {
    getContact () {
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/wp/v2/pages/`, {
        params: {
          slug: 'contact',
          lang
        }
      })
        .then(res => {
          if (res.data) {
            this.isContentLoaded = true
            this.contact = res.data[0]
            document.title = `${this.contact.title.rendered} - ${this.title}`
          }
        })
    }
  },
  watch: {
    '$route' () {
      this.getContact()
    }
  }
}
</script>
